import {Modal} from "react-bootstrap";
import {SvgIcon} from "./SvgIcon";
import Close from "../images/newDesign/close.nocolor.svg";
import Button from "../common/Button";
import {ConfirmDialogStyled} from "./ConfirmDialog.styled";
import {useTranslation} from "react-i18next";

/**
 * @param {string} title
 * @param {string} question
 * */
export function ConfirmDialog({ title, question, onClose }) {

    const {t} = useTranslation();

    return (
        <ConfirmDialogStyled show={true} onHide={() => onClose(false)} centered>
            <Modal.Header>
                <button onClick={() => onClose(false)}>
                    <SvgIcon href={Close} size={16}/>
                </button>
            </Modal.Header>
            <Modal.Body>
                <h1>{title}</h1>
                <div className="question">{question}</div>
                <div className="buttons">
                    <Button onClick={() => onClose(true)}>{t('common.buttons.confirm')}</Button>
                    <Button onClick={() => onClose(false)} className="secondary-button" >{t('common.buttons.cancel')}</Button>
                </div>
            </Modal.Body>
        </ConfirmDialogStyled>
    )
}
